"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.create = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const categoryService_1 = require("./service/categoryService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetch = (0, toolkit_1.createAsyncThunk)("categories/fetch", (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const categoriesService = new categoryService_1.CategoriesService(Env_1.APIPATHENV);
        const response = yield categoriesService.fetch(fetchPayload);
        return response;
    }
    catch (err) {
        throw new Error("Error in fetching categories");
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)("categories/create", (createPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const categoriesService = new categoryService_1.CategoriesService(Env_1.APIPATHENV);
        const response = yield categoriesService.create(createPayload);
        return response;
    }
    catch (err) {
        throw new Error("Error in creating categories");
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)("categories/update", (updatePayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const categoriesService = new categoryService_1.CategoriesService(Env_1.APIPATHENV);
        const response = yield categoriesService.update(updatePayload);
        return response;
    }
    catch (err) {
        throw new Error("Error in updating categories");
    }
}));
